import { Suspense, lazy } from 'react';

import { DynamicBaseBreadcrumb, DynamicDomainRegistrarsBreadcrumb } from '../../modules/AppBreadcrumb';
import { Spinner } from '../components';
import { AppControllerType, AppRoutes } from '../interfaces/router';

const DomainRegistrarsListPage = lazy(() => import('../../pages/DomainRegistrars/DomainRegistrarsList.page'));
const DomainRegistrarsCreatePage = lazy(() => import('../../pages/DomainRegistrars/DomainRegistrarsCreate.page'));
const DomainRegistrarsPage = lazy(() => import('../../pages/DomainRegistrars/DomainRegistrars.page'));

export const DomainRegistrarsController: AppControllerType = {
  common: [
    {
      path: AppRoutes.DomainRegistrars + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DomainRegistrarsListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicDomainRegistrarsBreadcrumb.DynamicDomainRegistrarsListBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.DomainRegistrarsCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DomainRegistrarsCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.DomainRegistrarsById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <DomainRegistrarsPage/>
        </Suspense>
      ),
      breadcrumb: DynamicDomainRegistrarsBreadcrumb.DynamicDomainRegistrarsByIdBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    }
  ]
};
